import { useEffect, useState } from "react";
// import { DefaultTable } from "../../../components/table.component";
import { Paginated } from "modules/dashboard/components/paginated.component";
import { usePagination } from "../../../hooks/usePagination";
import { rowTablePipe } from "../../../pipes/common";
import { getBenefitPurchases } from "../../../../../services/customers/customers.services";
import VuiTypography from "components/VuiTypography";
import { Table } from "modules/dashboard/components/table.component";
import { WITHDRAWAL_STATUS } from "constants/transactions";

const cols = [
  {
    label: "Partner",
    property: "partner",
    responsive: {
      state: true,
    },
  },
  {
    label: "Tipo",
    property: "type",
    responsive: {
      state: true,
    },
  },
  {
    label: "Email",
    property: "email",
    responsive: {
      state: true,
    },
  },
  {
    label: "Fecha",
    property: "date",
    responsive: {
      state: true,
    },
  },
  {
    label: "Desafío",
    property: "challenge",
    responsive: {
      state: true,
    },
  },
  {
    label: "Comisión",
    property: "commission",
    responsive: {
      state: true,
    },
  },
];

export function AssociateTableTable() {
  const [withdraws, setWithdraws] = useState([]);
  const { pagination, itemsCounter, setItemsCount, changePage, changeSize } = usePagination();

  const fetchWithdrawals = async () => {
    const result = await getBenefitPurchases({ pagination });
    const rowData = rowTablePipe(result.data.items);

    setItemsCount(result.data.itemsCounter);
    setWithdraws(rowData);
  };

  useEffect(() => {
    fetchWithdrawals();
  }, [pagination]);

  return (
    <>
      <CustomTable rows={withdraws} cols={cols} />
      <Paginated
        itemsCounter={itemsCounter}
        pageSize={pagination.paging_size}
        currentPage={pagination.paging_index}
        changePage={changePage}
        changeSize={changeSize}
      />
    </>
  );
}

export function CustomTable({ rows, cols }) {
  return (
    <Table
      columns={cols.map((item) => ({
        ...item,
        property: item.property,
        label: (
          <VuiTypography
            color="white"
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            {item.label}
          </VuiTypography>
        ),
        responsive: item.responsive,
        align: "left",
        styles: item.styles,
        dropDownName: item.label,
      }))}
      rows={rows.map((row) => {
        const mappedRow = {};
        cols.forEach((column) => {
          if (column.property === "status") {
            mappedRow[column.property] = {
              default: (
                <VuiTypography
                  color="white"
                  sx={{
                    fontSize: "12px",
                    lineHeight: "15.6px",
                    fontWeight: "500",
                    padding: "8px",
                  }}
                >
                  {WITHDRAWAL_STATUS[row[column.property]?.default ?? row.defaultValue]}
                </VuiTypography>
              ),
            };
          } else {
            mappedRow[column.property] = {
              default: (
                <VuiTypography
                  color="white"
                  sx={{
                    fontSize: "12px",
                    lineHeight: "15.6px",
                    fontWeight: "500",
                    padding: "8px",
                  }}
                >
                  {row[column.property]?.default ?? row.defaultValue}
                </VuiTypography>
              ),
            };
          }
        });
        return mappedRow;
      })}
    />
  );
}
